'use client';

import { useState, useEffect } from 'react';
import Link from 'next/link';
import Navbar from '../../../../components/Navbar';
import Footer from '../../../../components/Footer';
import PropertyCard from '../../../../components/PropertyCard';
import FilterPanel from '../../../../components/FilterPanel';
import HorizontalFilterBar from '../../../../components/HorizontalFilterBar';
import AdBanner from '../../../../components/AdBanner';
import { api } from '@/lib/apiClient';
import { useSearchParams } from 'next/navigation';

const BASE_URL = process.env.NEXT_PUBLIC_API_URL || '/api/proxy/';


const sortOptions = [
    { value: 'relevance', label: 'Relevance' },
    { value: 'rating', label: 'Top Rated' },
    { value: 'experience', label: 'Most Experienced' },
    { value: 'price_low', label: 'Price: Low to High' },
];

function convertToArray(str) {
    if (!str) return [];
    return str.split('-').map(num => parseInt(num, 10));
}

export default function CivilServicesPage() {
    const [filters, setFilters] = useState({});
    const [sortBy, setSortBy] = useState('relevance');
    const [isMobileFilterOpen, setIsMobileFilterOpen] = useState(false);

    const [mockServices, setMockServices] = useState([]);
    const [filteredServices, setFilteredServices] = useState([]);
    const searchParams = useSearchParams();
    const cityId = searchParams.get("cityId");
    const [city_name, setCityName] = useState("");
    const [localities, setLocalities] = useState("");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [parms, setParms] = useState("");

    // Read localities from query params if any are present
    const localitiesParam = searchParams.get("localities");
    const initialLocalities = localitiesParam ? localitiesParam.split('-').map(num => parseInt(num, 10)) : [];

    const [localitiesIds, setLocalitiesIds] = useState(initialLocalities);

    useEffect(() => {
        fetchProperties();
    }, [searchParams]);


    const fetchProperties = async () => {
        try {
            console.log("searchParams", searchParams.toString());
            setParms(searchParams.toString());
            const localitiesArray = convertToArray(searchParams.get("localities"));
            setLocalitiesIds(localitiesArray);
            let whereClause = "city_id=$1";
            let params = [cityId];

            const res = await api.post('selectwithout/view_home_cities', { sqlData: "*", where: "id=$1", whereData: [cityId] });
            //console.log("res.data", res.data);
            let city_name = res.data[0].name;
            setCityName(city_name);
            const res1 = await api.post('selectwithout/master_localities', {
                sqlData: "locality_name as name",
                where: "id = ANY($1)",
                whereData: [localitiesArray],
            });
            if (res1.success === 1 && Array.isArray(res1.data)) {
                let localitiesNames = "";
                for (let i = 0; i < res1.data.length; i++) {
                    localitiesNames += res1.data[i].name + ", ";
                }
                setLocalities(localitiesNames);
            }

            if (localitiesArray && localitiesArray.length > 0) {
                whereClause += " and locality_id = ANY($2)";
                params.push(localitiesArray);
            }

            whereClause += " order by created_at desc";

            const response = await api.post('selectwithout/view_admin_civil_suppliers',
                {
                    sqlData: "*",
                    where: whereClause,
                    whereData: params,
                });
            console.log("response.data", response.data);
            let service_cards = [];
            for (let i = 0; i < response.data.length; i++) {
                let service_card = {
                    id: response.data[i].id,
                    name: response.data[i].name,
                    price: 0,
                    priceUnit: "",
                    pricePerSqft: "",
                    type: response.data[i].services,
                    experience: response.data[i].experience,
                    rating: response.data[i].rating,
                    address: response.data[i].address,
                    city: response.data[i].city,
                    image: response.data[i].images,
                    imageCount: response.data[i].imageCount,
                    badges: response.data[i].badges,
                    isNew: response.data[i].isNew,
                    isVerified: response.data[i].isVerified,
                    isSaved: response.data[i].isSaved,
                    listingType: response.data[i].listingType,
                };
                service_cards.push(service_card);
            }
            setMockServices(service_cards);
        } catch (error) {
            console.error('Error fetching properties:', error);
        }
    };



    const handleFilterChange = (newFilters) => {
        setFilters(newFilters);
        // API call will go here
        console.log('Filters changed:', newFilters);
    };

    const handleSave = (serviceId) => {
        console.log('Save service:', serviceId);
    };

    const detailPath = `/civil/p/`;

    return (
        <>
            <Navbar />
            <main className="min-h-screen">
                {/* Horizontal Filter Bar - Sticky */}
                <div className="hidden lg:block sticky top-16 z-40 shadow-lg shadow-primary/10">
                    <HorizontalFilterBar
                        filters={filters}
                        onChange={handleFilterChange}
                        listingType="civil"
                    />
                </div>

                {/* Page Header */}
                <div className="bg-gray">
                    <div className="container-custom py-4">
                        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mt-5 mb-3">
                            <nav
                                className="flex flex-wrap items-center gap-2 text-sm text-gray-500 w-full"
                                aria-label="Breadcrumb"
                            >
                                <span className="text-gray-900 font-medium">
                                    <strong> Available {mockServices.length} Civil Services </strong> in Adyar, Chennai
                                </span>
                            </nav>
                            {/* <div className="flex items-center justify-between md:justify-end gap-2 w-full md:w-auto">
                                <label htmlFor="sortBy" className="text-sm text-gray-600 whitespace-nowrap">
                                    Sort by:
                                </label>
                                <select
                                    id="sortBy"
                                    value={sortBy}
                                    onChange={(e) => setSortBy(e.target.value)}
                                    className="h-9 w-full md:w-auto text-sm px-2 rounded-md bg-white border border-gray-300 text-gray-700 shadow-sm focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary"
                                >
                                    {sortOptions.map((opt) => (
                                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                                    ))}
                                </select>
                            </div> */}
                        </div>
                    </div>
                </div>

                {/* Main Content Split Layout */}
                <div className="container-custom py-8">
                    <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">

                        {/* Left: Service List (8 cols) */}
                        <div className="lg:col-span-8 flex flex-col gap-4">
                            {/* Mobile Filter Button */}
                            <div className="lg:hidden fixed bottom-0 left-0 right-0 z-10 bg-white border-t shadow-lg p-4">
                                <button
                                    onClick={() => setIsMobileFilterOpen(true)}
                                    className="btn btn-primary w-full flex justify-between items-center"
                                >
                                    <span className="flex items-center gap-2">
                                        <svg
                                            className="w-5 h-5"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth={2}
                                                d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
                                            />
                                        </svg>
                                        Filters
                                    </span>

                                    {Object.keys(filters).length > 0 && (
                                        <span className="bg-primary text-white text-xs px-2 py-0.5 rounded-full">
                                            {Object.keys(filters).length}
                                        </span>
                                    )}
                                </button>
                            </div>

                            {/* Service Cards Grid */}
                            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">
                                {mockServices.map((service) => (
                                    <Link
                                        href={`${detailPath}${service.id}?${parms}`}
                                        key={service.id}
                                        className="group bg-white border border-slate-200 rounded-2xl overflow-hidden hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 flex flex-col h-full"
                                    >

                                        {/* Content Section */}
                                        <div className="p-6 flex flex-col flex-grow">
                                            <div className="flex-grow">

                                                <div className="inline-flex items-center px-2 py-0.5 rounded-md text-[11px] font-medium bg-slate-100 text-slate-600 mb-3 capitalize">
                                                    {service.type || service.product_list}
                                                </div>
                                                <div className="flex items-start justify-between gap-2 mb-2">
                                                    <h3 className="text-base font-bold text-slate-800 line-clamp-2 group-hover:text-primary transition-colors leading-tight">
                                                        {service.name}
                                                    </h3>
                                                </div>
                                            </div>
                                            <div className="grid grid-cols-2 gap-2">
                                                <div className="flex flex-col group-hover:bg-violet-50/50 transition-colors">
                                                    <span className="text-xs text-slate-500 font-medium mb-0.5">Experience</span>
                                                    <div className="flex items-center gap-1 font-semibold text-slate-700 text-sm">
                                                        <span className="text-lg">⭐</span>
                                                        {service.experience}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="pt-3 mt-3 border-t border-slate-100 flex items-center justify-between">
                                                <div className="flex items-center gap-1.5 text-slate-500 text-xs overflow-hidden">
                                                    <svg className="w-3.5 h-3.5 shrink-0 text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                                    </svg>
                                                    <span className="truncate">{service.address}, {service.city}</span>
                                                </div>

                                                {service.rating && (
                                                    <div className="flex items-center gap-1 bg-yellow-50 px-1.5 py-0.5 rounded">
                                                        <span className="text-yellow-700 text-xs font-bold">{service.rating}</span>
                                                        <svg className="w-3 h-3 text-yellow-400 fill-current" viewBox="0 0 20 20">
                                                            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                                                        </svg>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </Link >
                                ))}
                            </div>

                            {/* Load More */}
                            {/* <div className="mt-8 text-center">
                                <button className="btn btn-white border border-gray-200 hover:border-primary hover:text-primary px-8 w-full sm:w-auto">
                                    Load More Services
                                </button>
                            </div> */}
                        </div>

                        {/* Right: Ad Sidebar (4 cols) */}
                        <aside className="lg:col-span-4 hidden lg:flex flex-col gap-3 sticky top-24">
                            <div className="p-6 bg-green-50 rounded-2xl border border-green-200">
                                <h3 className="text-lg font-bold text-green-900 mb-2">Become a Supplier</h3>
                                <p className="text-sm text-green-700 mb-4">
                                    Join our platform and connect with thousands of customers looking for civil services.
                                </p>
                                <Link href="/become-civil-suppliers" className="w-full btn bg-green-600 text-white hover:bg-green-700 border-none inline-block text-center">
                                    Register Now
                                </Link>
                            </div>
                            {/* <div className="p-6 bg-blue-50 rounded-2xl border border-blue-100">
                                <h3 className="text-lg font-bold text-blue-900 mb-2">Verified Professionals</h3>
                                <p className="text-sm text-blue-700 mb-4">
                                    Hire top-rated civil service experts for your home needs. Background checked & Verified.
                                </p>
                                <button className="w-full btn bg-blue-600 text-white hover:bg-blue-700 border-none">
                                    Post a Requirement
                                </button>
                            </div> */}

                            {/* Ad Banners */}
                            <AdBanner
                                type="services"
                                noofads={2}
                            />
                        </aside>
                    </div>
                </div>

                {/* Mobile Filter Modal */}
                {isMobileFilterOpen && (
                    <div className="fixed inset-0 z-50 lg:hidden">
                        <div
                            className="absolute inset-0 bg-black/50"
                            onClick={() => setIsMobileFilterOpen(false)}
                        />
                        <div className="absolute right-0 top-0 bottom-0 w-full max-w-sm bg-white overflow-y-auto">
                            <FilterPanel
                                filters={filters}
                                onChange={handleFilterChange}
                                listingType="civil"
                                isMobile={true}
                                onClose={() => setIsMobileFilterOpen(false)}
                            />
                        </div>
                    </div>
                )}
            </main>
            <Footer />
        </>
    );
}
